import React from 'react';

import { required, useRecordContext } from 'react-admin';
import { get } from 'lodash';

import { Grid, Typography } from '@mui/material';

import { useFormContext } from 'react-hook-form';

import SelectInput from '../../layout/inputFields/SelectInput';
import InfoPopover from '../../layout/InfoPopover';

import thresholdModes, { thresholdModeChoices, ThresholdModes } from '../../../constants/thresholdModes';

const ThresholdModeSelector = () => {
  const { setValue } = useFormContext();
  const record = useRecordContext();

  // Typed as `any` to satisfy SelectInput's onChange union (ChangeEvent | RaRecord);
  // this select is never used in create-suggestion mode, so it's always a ChangeEvent.
  const handleThresholdModeChange = (event: any) => {
    const newThresholdMode = event.target.value as ThresholdModes;
    if (newThresholdMode === thresholdModes.DEFAULT_ONLY) {
      setValue('ruleParameters.form', get(record, 'ruleParameters.form'));
      setValue('ruleParameters.kycFormDataMaxAge', get(record, 'ruleParameters.kycFormDataMaxAge'));
    }
    if (newThresholdMode === thresholdModes.KYC_ONLY) {
      setValue('ruleParameters.default', get(record, 'ruleParameters.default'));
    }
  };

  return (
    <Grid size={12}>
      <Grid container spacing={1}>
        <Grid size={12}>
          <Typography variant="label">Threshold mode</Typography>
        </Grid>
        <Grid size={12}>
          <SelectInput
            source="ruleParameters.thresholdMode"
            label="Threshold Mode"
            fullWidth
            choices={thresholdModeChoices}
            popups={(
              <InfoPopover
                key="threshold mode"
                title="Threshold mode"
                content="Select which threshold sources to use: Default only uses configured thresholds, KYC form only uses values from the KYC form, Both uses both with a priority setting."
              />
            )}
            validate={required()}
            onChange={handleThresholdModeChange}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ThresholdModeSelector;
